const breakpoints = { sm: '30em', md: '48em', lg: '62em', xl: '80em' };
export default breakpoints;
